import React, { useContext, useEffect, useState } from "react";
import Breadcrumb from "../../Component/Breadcrumb";
import { MyContext } from "../../hooks/useContextProvider";
import { useNavigate } from "react-router-dom";
import useBreakPoints from "../../hooks/useBreakPoints";
import { toast } from "react-toastify";
import Loader from "../../Component/Loader";
import { Minus, Plus, ShoppingCart, X } from "lucide-react";

const WishList = () => {
  const { wishList, callWishListApi } = useContext(MyContext);
  const navigate = useNavigate();
  const { isMobile } = useBreakPoints();
  console.log("wishList: ", wishList);
  const [loading, setloading] = useState(false);

  useEffect(() => {
    callWishListApi();
  }, []);

  async function deleteCartItem(id) {
    let formData = new FormData();
    const token = localStorage.getItem("token");
    let ipAddress = localStorage.getItem("ipaddress");

    formData.append("id", id);
    formData.append("clientId", process.env.REACT_APP_Client_Id);
    formData.append("isDelete", "Yes");
    formData.append("created_by", "customer");
    const requestOptions = {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Token ${token}`,
      },
    };
    fetch(
      `${process.env.REACT_APP_API_URL}deletewishlist?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        if (
          data &&
          (data.detail === "The Token is expired" ||
            data.message === "Invalid token" || data.message === "Invalid Credentials.")
        ) {
          localStorage.clear();
          navigate("/");
          window.location.reload();
        }
        if (data && data.status) {
          callWishListApi();
        }
        setloading(false);
      })
      .catch((error) => {
        setloading(false);
        setTimeout(() => {
          toast.error("There was an error, Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }, 1000);
      });
  }

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <Breadcrumb mainTitle={"Wishlist"} title={"Wishlist"} subTitle={"Home"} />
      <section className="container layout-pb-lg">
        {wishList?.length > 0 ? (
          <table
            className="custom-table-cart"
            style={{
              width: "100%",
              borderCollapse: "collapse",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    textAlign: "left",
                    padding: "10px",
                    borderBottom: "1px solid #ddd",
                    fontWeight: "normal",
                  }}
                >
                  PRODUCT
                </th>
                <th
                  style={{
                    textAlign: "left",
                    padding: "10px",
                    borderBottom: "1px solid #ddd",
                    fontWeight: "normal",
                  }}
                >
                  Price
                </th>
              </tr>
            </thead>
            <tbody>
              {wishList?.map((item, i) => {
                console.log("itemwishlist: ", item);
                return (
                  <tr
                    style={{ cursor: "pointer" }}
                    data-aos="zoom-out-left"
                    className="aos-init"
                    key={i}
                  >
                    <td
                      style={{
                        padding: "20px 10px",
                        borderBottom: "1px solid #ddd",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <button
                          style={{
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                            padding: "5px",
                            marginRight: "20px",
                            marginTop: 0,
                          }}
                        >
                          <X
                            color="black"
                            size={24}
                            onClick={() => deleteCartItem(item?.id)}
                          />
                        </button>
                        <img
                          onClick={() => {
                            navigate(
                              `/product-details/${item?.productDetails?.id}`
                            );
                          }}
                          src={
                            JSON.parse(
                              item?.productDetails?.productGallery?.replace(
                                /'/g,
                                '"'
                              ) || "[]"
                            )?.[0]
                          }
                          alt="Ring"
                          style={{
                            width: "120px",
                            height: "120px",
                            objectFit: "cover",
                            borderRadius: 12,
                          }}
                        />
                        <div
                          onClick={() => {
                            navigate(
                              `/product-details/${item?.productDetails?.id}`
                            );
                          }}
                          style={{
                            marginLeft: "20px",
                          }}
                        >
                          <div
                            className="unna-regular"
                            style={{ fontSize: 22, lineHeight: "26px" }}
                          >
                            {item?.productDetails?.productName}
                          </div>
                          <div className="jost-font mt-3">
                            {
                              item?.productDetails?.maincategory
                                ?.mainCategoryName
                            }
                            {item?.productDetails?.category?.categoryName &&
                              `- ${item?.productDetails?.category?.categoryName}`}
                          </div>
                        </div>
                      </div>
                    </td>

                    <td
                      style={{
                        padding: "20px 10px",
                        borderBottom: "1px solid #ddd",
                      }}
                    >
                      Rs.{" "}
                      {
                        item?.productDetails?.variants.reduce((min, variant) =>
                          parseInt(variant.price) < parseInt(min.price)
                            ? variant
                            : min
                        )?.price
                      }
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              fontFamily: "Nunito Sans, sans-serif",
              color: "#333",
              height: 345,
              padding: "20px",
            }}
          >
            <div
              style={{
                marginBottom: "20px",
                position: "relative",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100"
                height="100"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#ccc"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide custom-cart-svg lucide-shopping-cart"
              >
                <circle cx="8" cy="21" r="1"></circle>
                <circle cx="19" cy="21" r="1"></circle>
                <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"></path>
              </svg>
            </div>
            <h2
              className="unna-regular"
              style={{
                fontSize: "24px",
                fontWeight: "bold",
                marginBottom: "10px",
              }}
            >
              Your WishList is empty
            </h2>
            <p
              style={{
                fontSize: "16px",
                color: "#666",
                marginBottom: "20px",
              }}
            >
              You have no items in your WishList.
            </p>
            <button
              className="jost-font"
              onClick={() => {
                navigate("/shop");
              }}
              style={{
                backgroundColor: "#00264d",
                color: "white",
                border: "none",
                padding: "15px 20px",
                fontSize: "16px",
                fontWeight: "bold",
                cursor: "pointer",
                borderRadius: "5px",
              }}
            >
              CONTINUE SHOPPING
            </button>
          </div>
        )}
      </section>
    </>
  );
};

export default WishList;
